import { createContext, ReactNode, useContext } from "react";

type Context = { isAdminPortal: boolean };

const PortalContext = createContext<Context | undefined>(undefined);

const PortalProvider = ({ isAdminPortal, children }: { isAdminPortal: boolean; children: ReactNode }) => {
  return <PortalContext.Provider value={{ isAdminPortal }}>{children}</PortalContext.Provider>;
};

function usePortal() {
  const context = useContext(PortalContext);
  if (context === undefined) {
    throw new Error("usePortal must be used within a PortalProvider");
  }
  return context;
}

export { PortalProvider, usePortal };
